var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLicenseManagementBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "license-management",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0475633,0 C18.8759904,-1.52179594e-16 19.5475633,0.671572875 19.5475633,1.5 L19.5475633,18.5 C19.5475633,19.3284271 18.8759904,20 18.0475633,20 L16.5,20 C17.3284271,20 18,19.3284271 18,18.5 L18,18.5 L18,1.5 C18,0.671572875 17.3284271,-8.87970688e-16 16.5,0 L16.5,0 L18.0475633,0 Z",
    id: "Combined-Shape",
    fill: "#3B7FF5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#3B7FF5",
    strokeWidth: 1.3,
    x: 0.65,
    y: 0.65,
    width: 15.304757,
    height: 18.7,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#2E7EFE",
    strokeWidth: 1.5,
    x: 4.75,
    y: 3.75,
    width: 6.5,
    height: 4.5,
    rx: 2.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 8.46461367,
    x2: 8,
    y2: 16.7557954,
    id: "Path-2",
    stroke: "#2E7EFE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.30237849,
    y1: 16.1666667,
    x2: 11.2737816,
    y2: 16.1666667,
    id: "Path-3",
    stroke: "#2E7EFE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.78808007,
    y1: 14,
    x2: 11,
    y2: 14,
    id: "Path-3",
    stroke: "#2E7EFE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseManagementBorder);
export default __webpack_public_path__ + "static/media/license-management-border.d1358291986e81729b60c2f908576964.svg";
export { ForwardRef as ReactComponent };